import React from 'react';
import { motion } from 'framer-motion';
import { SearchX, Target, Compass, Sparkles } from 'lucide-react';
export function Problem() {
  const problems = [{
    icon: <SearchX className="text-red-500" size={32} data-id="element-209" />,
    title: 'Demasiada información',
    text: 'Cursos, videos y consejos por todos lados, pero sin una ruta clara para ejecutar.'
  }, {
    icon: <Target className="text-orange-500" size={32} data-id="element-210" />,
    title: 'Pocas acciones reales',
    text: 'Aprendes conceptos, pero no sabes cómo convertirlos en campañas, leads o ventas.'
  }, {
    icon: <Compass className="text-gray-500" size={32} data-id="element-211" />,
    title: 'Trabajas sin dirección',
    text: 'Intentas avanzar solo, sin feedback, sin comunidad y sin una estrategia concreta.'
  }];
  return <section className="py-12 lg:py-16 bg-gray-50 relative" data-id="element-212">
      <div className="container mx-auto px-4 md:px-6" data-id="element-213">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-214">
          <h2 className="text-3xl md:text-4xl font-bold text-link-dark mb-4" data-id="element-215">
            ¿Te sientes perdido con tanto contenido de marketing?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-10" data-id="element-216">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-217">
              <div className="w-14 h-14 rounded-2xl bg-gray-50 flex items-center justify-center mb-4" data-id="element-218">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-link-dark mb-2" data-id="element-219">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-220">{problem.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative max-w-4xl mx-auto" data-id="element-221">
          {/* Glow effect behind card */}
          <div className="absolute -inset-2 bg-gradient-to-r from-link-blue via-cyan-400 to-link-blue rounded-[2rem] blur-2xl opacity-40 animate-pulse" data-id="element-222" />

          <div className="relative bg-gradient-to-br from-link-navy via-blue-800 to-link-blue p-8 md:p-10 rounded-[2rem] overflow-hidden shadow-2xl shadow-link-blue/30" data-id="element-223">
            {/* Decorative dots pattern */}
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9IiNGRkZGRkYiIG9wYWNpdHk9IjAuMiIvPjwvc3ZnPg==')] opacity-40" data-id="element-224" />

            {/* Decorative blobs */}
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-cyan-400/30 rounded-full blur-3xl" data-id="element-225" />
            <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-link-blue/40 rounded-full blur-3xl" data-id="element-226" />

            {/* Sparkle icon */}
            <motion.div animate={{
            rotate: [0, 15, -15, 0],
            scale: [1, 1.1, 1]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="relative mx-auto w-14 h-14 mb-4 bg-white/15 backdrop-blur-sm rounded-2xl flex items-center justify-center border border-white/20 shadow-lg" data-id="element-227">
              <Sparkles className="text-white" size={32} fill="white" data-id="element-228" />
            </motion.div>

            <p className="relative text-center text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight" data-id="element-229">
              Link Academy existe para darte{' '}
              <span className="bg-gradient-to-r from-cyan-200 to-white bg-clip-text text-transparent" data-id="element-230">
                dirección, herramientas y acompañamiento.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}